<template>
  <div>
    <PageAllow controller="OrderRulers" :action="allowPermission" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{
            $t(isNew ? "CRUD.newInfo" : "CRUD.editInfo", [
              ruleType == 1
                ? $t("MaterialOrderRule.minOrderRule.title")
                : ruleType == 2
                ? $t("MaterialOrderRule.numberMatchRule.title")
                : ruleType == 3
                ? $t("MaterialOrderRule.maxOrderRule.title")
                : ruleType == 4
                ? $t("MaterialOrderRule.minOrderMoneyRule.title")
                : ruleType == 5
                ? $t("MaterialOrderRule.autoStandardRule.title")
                : ruleType == 6
                ? $t("MaterialOrderRule.mixProductRule.title")
                : ruleType == 7
                ? $t("MaterialOrderRule.expressFee.title")
                : "",
            ])
          }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="
                  $permission.checkAccountExpired().then(() => {
                    $router.replace('/material-order-rules?type=' + ruleType);
                  })
                "
                >fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("MaterialOrderRule.ObjectName")]) }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-row
          v-if="
            ruleType == 1 ||
            ruleType == 2 ||
            ruleType == 3 ||
            ruleType == 4 ||
            ruleType == 5
          "
          align="center"
          class="ma-0 bgGreen"
          style="height: 45px"
        >
          <span class="mx-7 subtitle-2 font-weight-bold">
            {{
              ruleType == 1
                ? $t("MaterialOrderRule.minOrderRule.hint")
                : ruleType == 2
                ? $t("MaterialOrderRule.numberMatchRule.hint")
                : ruleType == 3
                ? $t("MaterialOrderRule.maxOrderRule.hint")
                : ruleType == 4
                ? $t("MaterialOrderRule.minOrderMoneyRule.hint")
                : ruleType == 5
                ? $t("MaterialOrderRule.autoStandardRule.hint")
                : ""
            }}
          </span>
        </v-row>
        <v-card-text>
          <v-container>
            <ValidationObserver ref="observer">
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MaterialOrderRule.Fields.rule_name") +
                    $t("Global.colon")
                  }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('MaterialOrderRule.Fields.rule_name')"
                    rules="required"
                  >
                    <v-text-field
                      single-line
                      v-model="order_rule.name"
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'name')
                          .concat(errors)
                      "
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ order_rule.name }}
                </v-col>
              </v-row>
              <!-- 最小/大订货数 -->
              <v-row align="center" v-if="ruleType == 1 || ruleType == 3">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    ruleType == 1
                      ? $t("MaterialOrderRule.minOrderRule.min_order_num")
                      : $t("MaterialOrderRule.maxOrderRule.max_order_num")
                  }}
                  {{ $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('MaterialOrderRule.minOrderRule.min_order_num')"
                    rules="required"
                  >
                    <v-text-field
                      single-line
                      v-model="conditions.num"
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'num')
                          .concat(errors)
                      "
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ conditions.num | formatTwoDot }}
                </v-col>
              </v-row>
              <!-- 最小订货金额 -->
              <v-row align="center" v-if="ruleType == 4">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MaterialOrderRule.minOrderMoneyRule.min_order_money") +
                    $t("Global.colon")
                  }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('MaterialOrderRule.minOrderRule.min_order_num')"
                    rules="required"
                  >
                    <v-text-field
                      single-line
                      v-model="conditions.total_price"
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'name')
                          .concat(errors)
                      "
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ $t("Global.money")
                  }}{{ conditions.total_price | formatMoney }}
                </v-col>
              </v-row>
              <!-- 优先级数字 -->
              <v-row align="center" v-if="ruleType == 6">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MaterialOrderRule.mixProductRule.priority") +
                    $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-text-field single-line v-model="order_rule.sort">
                    <template v-slot:message="{ key, message }">
                      <div :class="key == 0 ? 'danger--text' : ''">
                        {{ message }}
                      </div>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ order_rule.sort }}
                </v-col>
              </v-row>
              <!-- 活动时间 -->
              <v-row align="center" v-if="ruleType == 6">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MaterialOrderRule.mixProductRule.activity_time") +
                    $t("Global.colon")
                  }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-row>
                    <v-col cols="5" md="4">
                      <!-- <ValidationProvider
                        v-slot="{ errors }"
                        :name="$t('MaterialOrderRule.mixProductRule.activity_time')"
                        rules="required"
                      > -->
                      <SearcherDatetime
                        class="my-n2"
                        v-model="order_rule.date_from"
                        type="date"
                        single-line
                        dense
                        hide-details
                        hide-icon
                        disabledBeforeToday
                      >
                        <template v-slot:message="{ key, message }">
                          <div :class="key == 0 ? 'danger--text' : ''">
                            {{ message }}
                          </div>
                        </template>
                      </SearcherDatetime>
                      <!-- </ValidationProvider> -->
                    </v-col>
                    <v-col cols="1" class="text-center">~</v-col>
                    <v-col cols="5" md="4">
                      <!-- <ValidationProvider
                        v-slot="{ errors }"
                        :name="$t('MaterialOrderRule.mixProductRule.activity_time')"
                        rules="required"
                      > -->
                      <SearcherDatetime
                        class="my-n2"
                        v-model="order_rule.date_to"
                        type="date"
                        single-line
                        dense
                        hide-details
                        hide-icon
                        disabledBeforeToday
                      >
                        <template v-slot:message="{ key, message }">
                          <div :class="key == 0 ? 'danger--text' : ''">
                            {{ message }}
                          </div>
                        </template>
                      </SearcherDatetime>
                      <!-- </ValidationProvider> -->
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ order_rule.date_from | formatDate }}
                  ~
                  {{ order_rule.date_to | formatDate }}
                </v-col>
              </v-row>
              <!-- 单笔最多下单数量 -->
              <v-row align="center" v-if="ruleType == 6">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("MaterialOrderRule.mixProductRule.single_max_num") }}
                  {{ $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-text-field single-line v-model="conditions.max">
                    <template v-slot:message="{ key, message }">
                      <div :class="key == 0 ? 'danger--text' : ''">
                        {{ message }}
                      </div>
                    </template>
                  </v-text-field>
                  <!-- </ValidationProvider> -->
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ conditions.max | formatTwoDot }}
                </v-col>
              </v-row>
              <!-- 是否响应要货模板 -->
              <v-row align="center" v-if="ruleType == 6">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MaterialOrderRule.mixProductRule.useTemplate") +
                    $t("Global.colon")
                  }}
                  <!-- <Required :show="savable" :mode="mode" /> -->
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-checkbox
                    v-model="conditions.check_template"
                    :hint="$t('MaterialOrderRule.mixProductRule.hint')"
                    true-value="1"
                    false-value="0"
                    persistent-hint
                    small
                  ></v-checkbox>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{
                    conditions.check_template
                      ? $t("MaterialOrderRule.mixProductRule.useTemplateOn")
                      : $t("MaterialOrderRule.mixProductRule.useTemplateOff")
                  }}
                </v-col>
              </v-row>
              <!-- 组合商品图片 -->
              <v-row align="center" v-if="ruleType == 6">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MaterialOrderRule.mixProductRule.mix_material_img") +
                    $t("Global.colon")
                  }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7">
                  <v-card v-if="img" max-width="240">
                    <v-img
                      :src="img"
                      @click.stop="$showFullscreenImages([img])"
                    >
                      <v-tooltip right v-if="savable && img">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            color="secondary"
                            class="pa-2 float-right"
                            @click.stop="
                              !img.startsWith('data:image/') &&
                              img == order_rule.img
                                ? (order_rule.img = img = null)
                                : (img = null)
                            "
                          >
                            fa-times
                          </v-icon>
                        </template>
                        <span>
                          {{
                            $t("MaterialOrderRule.mixProductRule.delImg")
                          }}</span
                        >
                      </v-tooltip>
                    </v-img>
                  </v-card>
                  <v-file-input
                    v-if="savable"
                    ref="img_file"
                    show-size
                    prepend-icon="fa-camera"
                    accept="image/png, image/jpeg"
                    persistent-hint
                    :placeholder="$t('Material.imgPlaceholder')"
                    :hint="$t('Material.imgHint')"
                    :rules="imgRules"
                    v-model="img_file"
                  >
                  </v-file-input>
                </v-col>
              </v-row>
              <!-- 组合商品分账接口 -->
              <v-row
                align="center"
                v-if="ruleType == 6 && settings && settings.sub_account_enable"
              >
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("MaterialOrderRule.Fields.sub_account_pay_type")
                  }}{{ $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-select
                    v-model="conditions.sub_account_pay_type"
                    :items="bankSelect"
                    item-value="value"
                    item-text="text"
                  ></v-select>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{
                    bankSelect.find(
                      (b) => b.value == conditions.sub_account_pay_type
                    )
                      ? bankSelect.find(
                          (b) => b.value == conditions.sub_account_pay_type
                        ).text
                      : ""
                  }}
                </v-col>
              </v-row>
              <v-row align="center" v-if="ruleType == 1 || ruleType == 3">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MaterialOrderRule.Fields.must_verify") +
                    $t("Global.colon")
                  }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-checkbox
                    v-model="conditions.must_flg"
                    :hint="$t('MaterialOrderRule.munstVerifyFlgs.hint')"
                    true-value="1"
                    false-value="0"
                    persistent-hint
                    small
                  ></v-checkbox>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{
                    conditions.must_flg == 1
                      ? $t("MaterialOrderRule.munstVerifyFlgs.on")
                      : $t("MaterialOrderRule.munstVerifyFlgs.off")
                  }}
                </v-col>
              </v-row>
              <!-- 要货商品 -->
              <v-row
                v-if="
                  ruleType != 2 &&
                  ruleType != 4 &&
                  ruleType != 5 &&
                  ruleType != 7
                "
              >
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    ruleType == 6
                      ? $t("MaterialOrderRule.Fields.material_name")
                      : $t("MaterialOrderRule.Fields.materials")
                  }}{{ $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                  <br />
                  <v-btn
                    v-if="savable"
                    color="primary"
                    class="my-1 mr-3"
                    x-small
                    outlined
                    @click="materials_dialog = true"
                  >
                    {{
                      $t(
                        "CRUD.chooseInfo",
                        ruleType == 6
                          ? [$t("MaterialOrderRule.Fields.material")]
                          : [$t("MaterialOrderRule.Fields.materials")]
                      )
                    }}
                  </v-btn>
                </v-col>
                <v-col cols="9" md="7">
                  <v-card-text v-if="ruleType == 6">
                    <v-row>
                      <span class="font-weight-bold me-2">
                        {{ $t("MaterialOrderRule.mixProductRule.group_money")
                        }}{{ $t("Global.colon") }}
                      </span>
                      <span>
                        {{ $t("Global.money") }}
                        {{ price | formatMoney }}
                      </span>
                    </v-row>
                  </v-card-text>
                  <v-data-table
                    :headers="materialHeaders"
                    :items="materialItems"
                    :loading="materialsLoading"
                    multi-sort
                    class="elevation-1 px-4 pt-2"
                    disable-pagination
                    hide-default-footer
                    fixed-header
                  >
                    <template v-slot:header.actions="{ header }">
                      {{ header.text }}
                      <v-icon x-small>fa-sliders-h</v-icon>
                    </template>
                    <template v-slot:item.num="{ item }">
                      <NumberInput v-if="savable" v-model="item.num" dense />
                      <span v-else>{{ item.num }}</span>
                    </template>
                    <template v-slot:item.price="{ item }">
                      <v-text-field
                        v-if="savable"
                        v-model="item.price"
                        single-line
                        dense
                        hide-details
                        type="number"
                        min="0"
                        :prefix="$t('Global.money')"
                        style="max-width: 80px; margin-left: auto"
                        @blur="
                          item.price = $numberFormatter.formatMoney(item.price)
                        "
                      />
                      <span v-else>
                        {{ $t("Global.money") }}{{ item.price }}
                      </span>
                    </template>
                    <template v-slot:item.split_price="{ item }">
                      <v-btn
                        v-if="settings && settings.sub_account_enable"
                        small
                        text
                        color="info"
                        @click="splitPriceItem = item"
                      >
                        {{ $t("Opt.details") }}
                      </v-btn>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <!-- 删除商品按钮 -->
                      <v-btn
                        small
                        text
                        class="danger--text pa-0"
                        @click="
                          materials.splice(
                            materials.findIndex(
                              (material) => material.id == item.id
                            ),
                            1
                          )
                        "
                      >
                        <v-icon>fa-times</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
              <!-- 数量匹配规则：要货商品A -->
              <v-row v-if="ruleType == 2 || ruleType == 5">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MaterialOrderRule.numberMatchRule.materialsA") +
                    $t("Global.colon")
                  }}
                  <Required :show="savable" :mode="mode" />
                  <br />
                  <v-btn
                    v-if="savable"
                    color="primary"
                    class="my-1 mr-3"
                    x-small
                    outlined
                    @click="materialAs_dialog = true"
                  >
                    {{
                      $t("CRUD.chooseInfo", [
                        $t("MaterialOrderRule.Fields.material"),
                      ])
                    }}
                  </v-btn>
                </v-col>
                <v-col cols="9" md="7">
                  <v-data-table
                    :headers="materialHeaders"
                    :items="materialAItems"
                    :loading="materialAsLoading"
                    multi-sort
                    class="elevation-1 px-4 pt-2"
                    disable-pagination
                    hide-default-footer
                    fixed-header
                  >
                    <template v-slot:header.actions="{ header }">
                      {{ header.text }}
                      <v-icon x-small>fa-sliders-h</v-icon>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-btn
                        small
                        text
                        class="danger--text pa-0"
                        @click="
                          materialAs.splice(
                            materialAs.findIndex(
                              (material) => material.id == item.id
                            ),
                            1
                          )
                        "
                      >
                        <v-icon>fa-times</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
              <!-- 自动标配 -->
              <v-row align="center" v-if="ruleType == 5">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MaterialOrderRule.autoStandardRule.proportion") +
                    $t("Global.colon")
                  }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('MaterialOrderRule.autoStandardRule.proportion')"
                    rules="required"
                  >
                    <v-text-field
                      single-line
                      v-model="conditions.num"
                      :placeholder="
                        $t(
                          'MaterialOrderRule.autoStandardRule.proportion_placeholder'
                        )
                      "
                      type="number"
                      :error-messages="errors"
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ conditions.num | formatTwoDot }}
                </v-col>
              </v-row>
              <!-- 四舍五入 -->
              <v-row align="center" v-if="ruleType == 5">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t(
                      "MaterialOrderRule.autoStandardRule.round_numbers_type"
                    ) + $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-select
                    v-model="conditions.math"
                    :items="$consts.orderRule.round_numbers_types"
                    item-value="value"
                    item-text="text"
                    :label="$t('MaterialOrderRule.roundNumbersTypes.title')"
                  ></v-select>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ conditions.math | roundNumbersTypesText }}
                </v-col>
              </v-row>
              <!-- 数量匹配规则：要货商品B -->
              <v-row v-if="ruleType == 2 || ruleType == 5">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MaterialOrderRule.numberMatchRule.materialsB") +
                    $t("Global.colon")
                  }}
                  <Required :show="savable" :mode="mode" />
                  <br />
                  <v-btn
                    v-if="savable"
                    color="primary"
                    class="my-1 mr-3"
                    x-small
                    outlined
                    @click="materialBs_dialog = true"
                  >
                    {{
                      $t("CRUD.chooseInfo", [
                        $t("MaterialOrderRule.Fields.material"),
                      ])
                    }}
                  </v-btn>
                </v-col>
                <v-col cols="9" md="7">
                  <v-data-table
                    :headers="materialHeaders"
                    :items="materialBItems"
                    :loading="materialBsLoading"
                    multi-sort
                    class="elevation-1 px-4 pt-2"
                    disable-pagination
                    hide-default-footer
                    fixed-header
                  >
                    <template v-slot:header.actions="{ header }">
                      {{ header.text }}
                      <v-icon x-small>fa-sliders-h</v-icon>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-btn
                        small
                        text
                        class="danger--text pa-0"
                        @click="
                          materialBs.splice(
                            materialBs.findIndex(
                              (material) => material.id == item.id
                            ),
                            1
                          )
                        "
                      >
                        <v-icon>fa-times</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
              <!-- 最小订货金额规则 -->
              <v-row style="display: none" v-if="ruleType == 4">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MaterialOrderRule.minOrderMoneyRule.use_promotion") +
                    $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-checkbox
                    v-model="conditions.cps_flg"
                    :hint="
                      $t(
                        'MaterialOrderRule.minOrderMoneyRule.use_promotion_hint'
                      )
                    "
                    true-value="1"
                    false-value="0"
                    persistent-hint
                    small
                  ></v-checkbox>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{
                    conditions.cps_flg
                      ? $t(
                          "MaterialOrderRule.minOrderMoneyRule.use_promotion_on"
                        )
                      : $t(
                          "MaterialOrderRule.minOrderMoneyRule.use_promotion_off"
                        )
                  }}
                </v-col>
              </v-row>
              <v-row v-if="ruleType == 4">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MaterialOrderRule.minOrderMoneyRule.apply_combine") +
                    $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-checkbox
                    v-model="conditions.combine_flg"
                    :hint="
                      $t(
                        'MaterialOrderRule.minOrderMoneyRule.apply_combine_hint'
                      )
                    "
                    :true-value="'1'"
                    :false-value="'0'"
                    persistent-hint
                    small
                  ></v-checkbox>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{
                    conditions.combine_flg == "1"
                      ? $t(
                          "MaterialOrderRule.minOrderMoneyRule.apply_combine_on"
                        )
                      : $t(
                          "MaterialOrderRule.minOrderMoneyRule.apply_combine_off"
                        )
                  }}
                </v-col>
              </v-row>
              <v-row v-if="ruleType == 4">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t(
                      "MaterialOrderRule.minOrderMoneyRule.standard_configuration"
                    ) + $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-checkbox
                    v-model="conditions.make_auto_flg"
                    :hint="
                      $t(
                        'MaterialOrderRule.minOrderMoneyRule.standard_configuration_hint'
                      )
                    "
                    true-value="1"
                    false-value="0"
                    persistent-hint
                    small
                  ></v-checkbox>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{
                    conditions.make_auto_flg
                      ? $t(
                          "MaterialOrderRule.minOrderMoneyRule.standard_configuration_on"
                        )
                      : $t(
                          "MaterialOrderRule.minOrderMoneyRule.standard_configuration_off"
                        )
                  }}
                </v-col>
              </v-row>
              <!-- 分组 -->
              <v-row v-if="ruleType != 7">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MaterialOrderRule.Fields.application_districts") +
                    $t("Global.colon")
                  }}
                  <br />
                  <span v-if="savable">
                    <v-btn
                      color="primary"
                      class="my-1 mr-3"
                      x-small
                      outlined
                      @click="districts_dialog = true"
                    >
                      {{
                        $t("CRUD.chooseInfo", [
                          $t("MaterialOrderRule.Fields.application_districts"),
                        ])
                      }}
                    </v-btn>
                    <br />
                    <span class="text-caption">
                      {{ $t("MaterialOrderRule.Fields.districts_hint") }}
                    </span>
                  </span>

                  <!-- 适用组别 -->
                </v-col>
                <v-col cols="9" md="7">
                  <v-data-table
                    :headers="districtHeaders"
                    :items="districts"
                    :loading="districtsLoading"
                    multi-sort
                    class="elevation-1 px-4 pt-2"
                    disable-pagination
                    hide-default-footer
                    fixed-header
                  >
                    <template v-slot:header.actions="{ header }">
                      {{ header.text }}
                      <v-icon x-small>fa-sliders-h</v-icon>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-btn
                        small
                        text
                        class="danger--text pa-0"
                        @click="
                          districts.splice(
                            districts.findIndex(
                              (district) => district.id == item.id
                            ),
                            1
                          )
                        "
                      >
                        <v-icon>fa-times</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
              <!-- 运费规则描述 -->
              <v-row v-if="ruleType == 7">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MaterialOrderRule.expressFee.memo") + $t("Global.colon")
                  }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('MaterialOrderRule.expressFee.memo')"
                    rules="required"
                  >
                    <v-textarea
                      single-line
                      auto-grow
                      outlined
                      v-model="order_rule.memo"
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'name')
                          .concat(errors)
                      "
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-textarea>
                  </ValidationProvider>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ order_rule.memo }}
                </v-col>
              </v-row>
              <!-- 活动范围 -->
              <v-row v-if="ruleType == 7">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MaterialOrderRule.expressFee.range") +
                    $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7">
                  <span v-if="savable">
                    <v-radio-group row v-model="rangeFlag" class="mt-0">
                      <v-radio
                        v-for="stat in rangeTypeItems"
                        :key="stat.value"
                        :label="`${stat.text}`"
                        :value="stat.value"
                      ></v-radio>
                    </v-radio-group>
                    <!-- 按分组 -->
                    <v-btn
                      v-if="rangeFlag == 1"
                      color="primary"
                      class="my-1 mr-3"
                      outlined
                      @click="districts_one_dialog = true"
                    >
                      {{
                        $t("CRUD.chooseInfo", [
                          $t("MaterialOrderRule.Fields.application_districts"),
                        ])
                      }}
                    </v-btn>
                    <!-- 按区域 -->
                    <v-btn
                      v-if="rangeFlag == 2"
                      color="primary"
                      class="my-1 mr-3"
                      outlined
                      @click="cities_dialog = true"
                    >
                      {{
                        $t("CRUD.chooseInfo", [
                          $t("MaterialOrderRule.Fields.cities_districts"),
                        ])
                      }}
                    </v-btn>
                  </span>
                  <span v-else>
                    {{ rangeFlag | rangeTypesText }}
                  </span>
                  <br />
                  <!-- 已选分组 -->
                  <v-data-table
                    v-if="rangeFlag == 1"
                    :headers="districtHeaders"
                    :items="districts_one"
                    :loading="districtsLoading"
                    multi-sort
                    class="elevation-1 px-4 pt-2"
                    disable-pagination
                    hide-default-footer
                    fixed-header
                  >
                    <template v-slot:header.actions="{ header }">
                      {{ header.text }}
                      <v-icon x-small>fa-sliders-h</v-icon>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-btn
                        small
                        text
                        class="danger--text pa-0"
                        @click="
                          districts_one.splice(
                            districts_one.findIndex(
                              (district) => district.id == item.id
                            ),
                            1
                          )
                        "
                      >
                        <v-icon>fa-times</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                  <!-- 已选区域 -->
                  <v-card class="mx-4 mb-4" v-if="rangeFlag == 2">
                    <v-progress-linear
                      :indeterminate="loading"
                    ></v-progress-linear>
                    <!-- 已选择 -->
                    <v-card-title>
                      {{ $t("MaterialOrderRule.expressFee.choosed_cities") }}
                    </v-card-title>
                    <v-divider />
                    <v-treeview
                      class="py-2"
                      :items="confirmCities"
                      item-key="city_id"
                      item-text="name"
                      item-children="cities"
                      item-disabled="false"
                      open-all
                    >
                      <template v-slot:label="{ item }">
                        {{ item.name }}
                      </template>
                    </v-treeview>
                  </v-card>
                </v-col>
              </v-row>
              <!-- 启用包邮 -->
              <v-row align="center" v-if="ruleType == 7">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MaterialOrderRule.expressFee.free_money") +
                    $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-row>
                    <v-col>
                      <v-checkbox
                        v-model="freeFlag"
                        true-value="1"
                        false-value="0"
                        :hint="$t('MaterialOrderRule.expressFee.free_hint')"
                        persistent-hint
                        small
                      ></v-checkbox>
                    </v-col>
                    <v-col>
                      <v-row v-if="freeFlag == 1" class="mt-3">
                        <span class="text-h6">≥</span>
                        <v-text-field
                          v-model="conditions.free_money"
                          single-line
                          dense
                          hide-details
                          type="number"
                          :prefix="$t('Global.money')"
                          min="0"
                          style="margin: auto"
                        />
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  <span>
                    {{
                      freeFlag == 1
                        ? "≥ " + conditions.free_money
                        : $t("MaterialOrderRule.expressFee.free_money_off")
                    }}
                  </span>
                </v-col>
              </v-row>
              <!-- 运费计算依据 -->
              <v-row v-if="ruleType == 7">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MaterialOrderRule.expressFee.pay_type") +
                    $t("Global.colon")
                  }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7">
                  <v-row class="pl-3" v-if="savable">
                    <v-radio-group row v-model="pay_type">
                      <v-radio
                        v-for="stat in payTypeItems"
                        class="mt-n2"
                        :key="stat.value"
                        :label="`${stat.text}`"
                        :value="stat.value"
                      ></v-radio>
                    </v-radio-group>
                  </v-row>
                  <span v-else>
                    {{ pay_type | expressPayTypesText }}
                  </span>
                  <div class="mt-3">
                    <!-- 按照金额计算 -->
                    <v-data-table
                      v-if="pay_type == 1"
                      :headers="expressHeadersOne"
                      :items="expressItemsOne"
                      :loading="expressDetailsLoading"
                      multi-sort
                      class="elevation-1 px-4 pt-2"
                      disable-pagination
                      hide-default-footer
                      fixed-header
                    >
                      <template v-slot:header.actions="{ header }">
                        {{ header.text }}
                        <v-icon x-small>fa-sliders-h</v-icon>
                      </template>
                      <template v-slot:item.actions="{ index }">
                        <v-btn
                          v-if="index != 0"
                          small
                          text
                          class="danger--text pa-0"
                          @click="express_details_one.splice(index, 1)"
                        >
                          <v-icon>fa-times</v-icon>
                        </v-btn>
                      </template>
                      <template v-slot:item.step="{ index }">
                        {{ index + 1 }}
                      </template>
                      <template v-slot:item.order_fee="{ item }">
                        <v-text-field
                          v-if="savable"
                          v-model="item.order_fee"
                          single-line
                          dense
                          hide-details
                          :prefix="$t('Global.money')"
                          type="number"
                          min="0"
                          style="max-width: 80px; margin-left: auto"
                        />
                        <span v-else>
                          {{ $t("Global.money") + item.order_fee }}
                        </span>
                      </template>
                      <template v-slot:item.express_price="{ item }">
                        <v-text-field
                          v-if="savable"
                          v-model="item.express_price"
                          single-line
                          dense
                          hide-details
                          :prefix="$t('Global.money')"
                          type="number"
                          min="0"
                          style="max-width: 80px; margin-left: auto"
                        />
                        <span v-else>
                          {{ $t("Global.money") + item.express_price }}
                        </span>
                      </template>
                    </v-data-table>
                    <!-- 按照重量或数量计算 -->
                    <v-data-table
                      v-else
                      :headers="expressHeadersTwo"
                      :items="expressItemsTwo"
                      :loading="expressDetailsLoading"
                      multi-sort
                      class="elevation-1 px-4 pt-2"
                      disable-pagination
                      hide-default-footer
                      fixed-header
                    >
                      <template v-slot:header.actions="{ header }">
                        {{ header.text }}
                        <v-icon x-small>fa-sliders-h</v-icon>
                      </template>
                      <template v-slot:header.start="{ header }">
                        {{ header.text }}≤
                      </template>
                      <!-- <template v-slot:item.actions="{ index }">
                        <v-btn
                          small
                          text
                          class="danger--text pa-0"
                          @click="express_details_two.splice(index, 1)"
                        >
                          <v-icon>fa-times</v-icon>
                        </v-btn>
                      </template> -->
                      <template v-slot:item.start="{ item }">
                        <v-text-field
                          v-if="savable"
                          v-model="item.start"
                          single-line
                          dense
                          hide-details
                          type="number"
                          min="0"
                          style="max-width: 80px; margin-left: auto"
                        />
                        <span v-else>
                          {{ item.start }}
                        </span>
                      </template>
                      <template v-slot:item.express_price="{ item }">
                        <v-text-field
                          v-if="savable"
                          v-model="item.express_price"
                          single-line
                          dense
                          hide-details
                          :prefix="$t('Global.money')"
                          type="number"
                          min="0"
                          style="max-width: 80px; margin-left: auto"
                        />
                        <span v-else>
                          {{ $t("Global.money") + item.express_price }}
                        </span>
                      </template>
                      <template v-slot:item.add_num="{ item }">
                        <v-text-field
                          v-if="savable"
                          v-model="item.add_num"
                          single-line
                          dense
                          hide-details
                          type="number"
                          min="0"
                          style="max-width: 80px; margin-left: auto"
                        />
                        <span v-else>
                          {{ item.add_num }}
                        </span>
                      </template>
                      <template v-slot:item.add_price="{ item }">
                        <v-text-field
                          v-if="savable"
                          v-model="item.add_price"
                          single-line
                          dense
                          hide-details
                          :prefix="$t('Global.money')"
                          type="number"
                          min="0"
                          style="max-width: 80px; margin-left: auto"
                        />
                        <span v-else>
                          {{ $t("Global.money") + item.add_price }}
                        </span>
                      </template>
                    </v-data-table>
                    <span v-if="savable">
                      <br />
                      <v-btn
                        v-if="expressFlag == 1 && pay_type == 1"
                        color="primary"
                        class="my-1 mr-3"
                        outlined
                        @click="addExpressDetail()"
                      >
                        {{
                          $t("MaterialOrderRule.Fields.add_express_detail"),
                        }}
                      </v-btn>
                    </span>
                  </div>
                </v-col>
              </v-row>
              <!-- 启用阶梯运费 -->
              <v-row align="center" v-if="ruleType == 7 && pay_type == 1">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MaterialOrderRule.expressFee.express_details") +
                    $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-checkbox
                    v-model="expressFlag"
                    true-value="1"
                    false-value="0"
                    persistent-hint
                    :hint="$t('MaterialOrderRule.expressFee.express_hint')"
                    small
                  ></v-checkbox>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{
                    expressFlag == 1
                      ? $t("MaterialOrderRule.expressFee.express_details_on")
                      : $t("MaterialOrderRule.expressFee.express_details_off")
                  }}
                </v-col>
              </v-row>
            </ValidationObserver>
          </v-container>
        </v-card-text>
      </v-card>
      <v-sheet class="page-opts">
        <v-card>
          <v-card-title>
            <v-row dense>
              <v-col cols="12">
                <v-btn
                  outlined
                  color="secondary"
                  class="elevation-1"
                  block
                  @click="
                    $permission.checkAccountExpired().then(() => {
                      $router.replace('/material-order-rules?type=' + ruleType);
                    })
                  "
                >
                  <v-icon small class="pe-1">fa-times</v-icon>
                  {{
                    $t("CRUD.backToList", [$t("MaterialOrderRule.ObjectName")])
                  }}
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                v-if="
                  isView &&
                  $permission.permissionAllow('OrderRulers', 'saveMinQuantity')
                "
              >
                <v-btn
                  color="accent"
                  block
                  :disabled="loading && !order_rule.id"
                  @click="toEdit = true"
                >
                  <v-icon small class="pe-1">fa-pencil-alt</v-icon>
                  {{
                    $t("CRUD.editInfo", [$t("MaterialOrderRule.ObjectName")])
                  }}
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                v-if="
                  savable &&
                  $permission.permissionAllow('OrderRulers', 'saveMinQuantity')
                "
              >
                <v-btn
                  color="success"
                  block
                  :disabled="loading && !order_rule.id"
                  @click="submit()"
                >
                  <v-icon small class="pe-1">fa-save</v-icon>
                  {{
                    $t("CRUD.saveInfo", [$t("MaterialOrderRule.ObjectName")])
                  }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
        <v-card class="mt-4">
          <v-card-title>
            <v-row dense>
              <v-col cols="12">
                <v-btn color="primary" class="elevation-1 my-1" block>
                  <span class="mx-2">
                    {{ order_rule.status | orderRuleStatusText }}
                  </span>
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                v-if="
                  savable &&
                  $permission.permissionAllow('OrderRulers', 'updateStatus')
                "
              >
                <v-btn
                  v-if="order_rule.status"
                  outlined
                  color="primary"
                  class="elevation-1"
                  block
                  :disabled="loading && !order_rule.id"
                  @click="changeStatus()"
                >
                  {{ $t("MaterialOrderRule.Fields.stop_use") }}
                </v-btn>
                <v-btn
                  v-else
                  outlined
                  color="primary"
                  class="elevation-1"
                  block
                  :disabled="loading && !order_rule.id"
                  @click="useRuleDialog = true"
                >
                  {{ $t("MaterialOrderRule.Fields.start_use") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-sheet>
      <MaterialsSelectsDialog
        v-model="materials_dialog"
        fullField
        :materialIds="materialIds"
        @confirm="choosedMaterials = $event"
      />
      <MaterialsSelectsDialog
        v-model="materialAs_dialog"
        fullField
        :materialChoosed="materialAIds"
        @confirm="materialAs = $event"
      />
      <MaterialsSelectsDialog
        v-model="materialBs_dialog"
        fullField
        :materialChoosed="materialBIds"
        @confirm="materialBs = $event"
      />
      <DialogDistricts
        v-model="districts_dialog"
        :districtSelected="districts"
        @confirm="districts = $event"
      />
      <DialogDistricts
        v-model="districts_one_dialog"
        :districtSelected="districts_one"
        @confirm="districts_one = $event"
      />

      <DialogAlert
        v-model="useRuleDialog"
        :message="$t('MaterialOrderRule.Messages.useRule')"
        useConfirm
        persistent
        @confirm="changeStatus(true)"
      />
      <DialogAlert
        v-model="isLeaveDialog"
        :message="alertMessage"
        persistent
        useConfirm
        @confirm="confirmLeave = true"
      />
      <v-dialog persistent v-model="cities_dialog" width=" 800px">
        <v-card>
          <v-card-title>
            <span>
              {{ $t("MaterialOrderRule.expressFee.choose_area") }}
            </span>
            <v-spacer></v-spacer>
            <v-tooltip disabled>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="cities_dialog = false"
                  >fa-times
                </v-icon>
              </template>
            </v-tooltip>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text height="600px">
            <v-row class="overflow-auto">
              <v-col cols="5">
                <v-card class="mx-4 mb-4 flat">
                  <v-progress-linear
                    :indeterminate="loading"
                  ></v-progress-linear>
                  <!-- 可选择 -->
                  <v-card-title>
                    {{ $t("MaterialOrderRule.expressFee.enable_cities") }}
                  </v-card-title>
                  <v-divider />
                  <div class="overflow-auto">
                    <v-treeview
                      class="py-2 overflow-hidden"
                      v-model="selection"
                      :items="getCities"
                      selected-color="primary"
                      item-children="cities"
                      item-key="city_id"
                      item-text="name"
                      item-disabled="false"
                      selectable
                      return-object
                    >
                      <!-- <template v-slot:label="{ item }">
                    {{ item.name }}
                  </template> -->
                    </v-treeview>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="2" class="text-center">
                <v-btn
                  v-if="rangeFlag == 2"
                  color="primary"
                  class="my-1 mr-3 text-align-center"
                  outlined
                  @click="add()"
                >
                  {{
                    $t("MaterialOrderRule.Fields.add"),
                  }}
                </v-btn>
              </v-col>
              <v-col cols="5" class="overflow-hidden">
                <v-card class="mx-4 mb-4" height="100%">
                  <v-progress-linear
                    :indeterminate="loading"
                  ></v-progress-linear>
                  <!-- 已选择 -->
                  <v-card-title>
                    {{ $t("MaterialOrderRule.expressFee.choosed_cities") }}
                  </v-card-title>
                  <v-divider />
                  <v-treeview
                    class="py-2"
                    :items="choosedCities"
                    item-key="city_id"
                    item-text="name"
                    item-disabled="false"
                    item-children="cities"
                    open-all
                  >
                    <template v-slot:label="{ item }">
                      {{ item.name }}
                      <v-icon
                        small
                        color="accent"
                        class="px-1 py-4 me-1"
                        @click="cut(item.city_id)"
                        >fa-trash-alt
                      </v-icon>
                    </template>
                  </v-treeview>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" outlined @click="cities_dialog = false">{{
              $t("$vuetify.close")
            }}</v-btn>
            <v-btn
              color="accent"
              @click="
                confirmCities = choosedCities;
                cities_dialog = false;
              "
              >{{ $t("CRUD.save") }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-sheet>
    <SplitPrice
      v-model="splitPriceItem"
      :mode="mode"
      :bank_code="conditions.sub_account_pay_type"
      :price="splitPriceItem ? Number(splitPriceItem.price) : 0"
    />
  </div>
</template>
<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import Required from "@/components/plugins/Required";
import Consts from "@/consts.js";
import Cities from "@/api/cities.js";
import DialogDistricts from "@/components/plugins/DialogDistricts";
import MaterialsSelectsDialog from "@/components/plugins/MaterialsSelectsDialog";
import DialogAlert from "@/components/plugins/DialogAlert";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import OrderRules from "@/api/order_rules";
import SearcherDatetime from "@/components/plugins/SearcherDatetime";
import Files from "@/api/files";
import NumberInput from "@/components/plugins/NumberInput";
import SubAccounts from "@/api/sub_accounts";
import SplitPrice from "../templates/plugins/SplitPrice";

const defaultexpressDetailOne = [
  {
    order_fee: 0,
    express_price: 0,
  },
];
const defaultexpressDetailTwo = [
  {
    start: 0,
    express_price: 0,
    add_num: 0,
    add_price: 0,
  },
];
export default {
  components: {
    PageAllow,
    Breadcrumbs,
    Required,
    MaterialsSelectsDialog,
    DialogDistricts,
    DialogAlert,
    SearcherDatetime,
    ValidationObserver,
    ValidationProvider,
    NumberInput,
    SplitPrice,
  },

  computed: {
    allowPermission() {
      return (
        "view" ||
        "saveMinQuantity" ||
        "saveMaxQuantity" ||
        "saveQuantity" ||
        "saveAuto" ||
        "saveMinAmount" ||
        "saveCombineMaterial" ||
        "saveExpressFee"
      );
    },
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.materialManagement"),
          disabled: false,
          href: "/materials",
        },
        {
          text: i18n.t("Nav.materialOrderRules"),
          disabled: true,
          href: "/material-order-rules",
        },
      ];
    },
    isNew() {
      return this.mode == "new";
    },
    savable() {
      return this.mode == "edit" || this.mode == "new";
    },
    isView() {
      return this.mode == "view";
    },
    ruleType() {
      return this.$route.query.type;
    },

    materialHeaders() {
      var materialHeaders = [];
      if (this.ruleType != 6) {
        materialHeaders.push({
          text: i18n.t("MaterialOrderRule.Fields.category_name"),
          align: "start",
          sortable: false,
          value: "material_category.name",
        });
      }
      materialHeaders.push({
        text: i18n.t("MaterialOrderRule.Fields.material_name"),
        align: "start",
        sortable: false,
        value: "Description",
      });
      if (this.ruleType == 6) {
        materialHeaders.push(
          {
            text: i18n.t("MaterialOrderRule.Fields.num"),
            align: "start",
            class: "text-no-wrap",
            sortable: false,
            value: "num",
          },
          {
            text: i18n.t("MaterialOrderRule.Fields.price"),
            align: "start",
            sortable: false,
            class: "text-no-wrap",
            value: "price",
          }
        );
        if (this.settings && this.settings.sub_account_enable) {
          materialHeaders.push({
            text: i18n.t("MaterialOrderRule.Fields.split_price"),
            align: "start",
            sortable: false,
            class: "text-no-wrap",
            value: "split_price",
          });
        }
      }
      if (this.savable) {
        materialHeaders.push({
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        });
      }

      return materialHeaders;
    },
    districtHeaders() {
      var headers = [
        {
          text: i18n.t("MaterialOrderRule.Fields.district_code"),
          align: "start",
          sortable: false,
          value: "number",
        },
        {
          text: i18n.t("MaterialOrderRule.Fields.district_name"),
          align: "start",
          sortable: false,
          value: "name",
        },
      ];
      if (this.savable) {
        headers.push({
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        });
      }
      return headers;
    },
    // 按金额计算时的表头
    expressHeadersOne() {
      var headers = [
        {
          text: i18n.t("MaterialOrderRule.Fields.step"),
          align: "start",
          sortable: false,
          value: "step",
        },
        {
          text: i18n.t("MaterialOrderRule.Fields.start_money"),
          align: "start",
          sortable: false,
          value: "order_fee",
        },
        {
          text: i18n.t("MaterialOrderRule.Fields.express_price"),
          align: "start",
          sortable: false,
          value: "express_price",
        },
      ];
      if (this.savable) {
        headers.push({
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        });
      }
      return headers;
    },
    // 按数量和重量计算时的表头
    expressHeadersTwo() {
      var headers = [
        {
          text: i18n.t("MaterialOrderRule.Fields.start"),
          align: "start",
          sortable: false,
          value: "start",
        },
        {
          text: i18n.t("MaterialOrderRule.Fields.express_price"),
          align: "start",
          sortable: false,
          value: "express_price",
        },
      ];
      if (this.pay_type == 2) {
        headers.push({
          text: i18n.t("MaterialOrderRule.Fields.add_num"),
          align: "start",
          sortable: false,
          value: "add_num",
        });
      } else if (this.pay_type == 3) {
        headers.push({
          text: i18n.t("MaterialOrderRule.Fields.add_num2"),
          align: "start",
          sortable: false,
          value: "add_num",
        });
      }
      headers.push({
        text: i18n.t("MaterialOrderRule.Fields.add_price"),
        align: "start",
        sortable: false,
        value: "add_price",
      });
      if (this.savable) {
        headers.push({
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        });
      }
      return headers;
    },

    expressItemsOne() {
      return this.express_details_one;
    },
    expressItemsTwo() {
      return this.express_details_two;
    },

    materialItems() {
      return this.materials.map((detail) => {
        detail.Description = i18n.t(
          this.settings
            ? this.settings.material_name_display_type == 4
              ? "Material.nameWithCodeAndStandard"
              : this.settings.material_name_display_type == 3
              ? "Material.materialNameWithCodeAndStandard"
              : this.settings.material_name_display_type == 2
              ? "Material.materialNameWithCode"
              : "Material.materialName"
            : "Material.materialName",
          [detail.material_code, detail.material_name, detail.standard_name]
        );
        return detail;
      });
    },

    materialAItems() {
      return this.materialAs.map((detail) => {
        detail.Description = i18n.t(
          this.settings
            ? this.settings.material_name_display_type == 4
              ? "Material.nameWithCodeAndStandard"
              : this.settings.material_name_display_type == 3
              ? "Material.materialNameWithCodeAndStandard"
              : this.settings.material_name_display_type == 2
              ? "Material.materialNameWithCode"
              : "Material.materialName"
            : "Material.materialName",
          [detail.material_code, detail.material_name, detail.standard_name]
        );
        return detail;
      });
    },

    materialBItems() {
      return this.materialBs.map((detail) => {
        detail.Description = i18n.t(
          this.settings
            ? this.settings.material_name_display_type == 4
              ? "Material.nameWithCodeAndStandard"
              : this.settings.material_name_display_type == 3
              ? "Material.materialNameWithCodeAndStandard"
              : this.settings.material_name_display_type == 2
              ? "Material.materialNameWithCode"
              : "Material.materialName"
            : "Material.materialName",
          [detail.material_code, detail.material_name, detail.standard_name]
        );
        return detail;
      });
    },
    payTypeItems() {
      return Consts.orderRule.pay_types;
    },
    rangeTypeItems() {
      return Consts.orderRule.range_types;
    },
    // cityItems() {
    //   console.log(this.getCities);
    //   return this.getCities.map((detail) => {
    //     var cities = [];
    //     if (detail.cities && Array.isArray(detail.cities)) {
    //       detail.cities.forEach((detail) => {
    //         cities.push({ id: detail.city_id, name: detail.name });
    //         delete detail.disabled;
    //         detail.id = detail.city_id;
    //       });
    //     }
    //     console.log(cities);
    //     return {
    //       id: detail.city_id,
    //       name: detail.name,
    //       children: cities,
    //     };
    //   });
    // },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    img: "",
    img_file: null,
    price: 0, //组合金额
    mode: "",
    choosedMaterials: [], //每次选中的商品
    order_rule: {},
    conditions: { max: 1 },
    serverErrors: [],
    materials_dialog: false,
    materials: [],
    materialIds: [],
    materialsLoading: false,
    materialAs_dialog: false,
    materialAs: [],
    materialAIds: [],
    materialAsLoading: false,
    materialBs_dialog: false,
    materialBs: [],
    materialBIds: [],
    materialBsLoading: false,
    districts_dialog: false,
    districts: [],
    districtsLoading: false,
    useRuleDialog: false,
    submit_data: {},
    imgRules: [
      (value) => !value || value.size < 5000000 || i18n.t("Material.imgHint"),
    ],
    freeFlag: "0",
    pay_type: 1,
    expressFlag: "0",
    expressDetailsLoading: false,
    // const newArr = JSON.parse(JSON.stringify(defaultexpressDetailOne))
    express_details_one: JSON.parse(JSON.stringify(defaultexpressDetailOne)), //当pay_type为1按照金额计算运费时
    express_details_two: JSON.parse(JSON.stringify(defaultexpressDetailTwo)), //当pay_type为2、3按照数量和重量计算运费时
    rangeFlag: 1,
    getCities: [], //所有省市区
    cities_dialog: false,
    selection: [], //被选择的城市
    choosedCities: [], //被选择的城市
    confirmCities: [], //确认的被选择的城市
    districts_one: [], //range_type为1时的活动范围
    districts_two: [], //range_type为2时的活动范围
    districts_one_dialog: false,
    bankSelect: [],
    splitPriceItem: null,
    isLeave: false,
    isLeaveDialog: false,
    alertMessage: "",
    confirmLeave: false,
    toPage: "",
    toEdit: false,
  }),

  mounted() {
    if (this.$route.params.id == 0) {
      this.mode = "new";
    } else {
      this.mode = this.$route.query.mode ? this.$route.query.mode : "view";
      this.getOrderRuleFromAPI(this.$route.params.id);
    }
    // 获取省市
    Cities.cities().then(
      function (response) {
        if (response.data.status.isOK()) {
          this.getCities = JSON.parse(
            JSON.stringify(response.data.cities.cities)
          );
        }
      }.bind(this)
    );
    // 获取分账接口备选项
    SubAccounts.fetchBankSelect().then(
      function (response) {
        if (response.data.status.isOK()) {
          this.bankSelect = Object.keys(response.data.banks).map((key) => {
            return {
              text: response.data.banks[key],
              value: key,
            };
          });
        }
      }.bind(this)
    );
  },

  methods: {
    getOrderRuleFromAPI(id) {
      OrderRules.fetchOne(id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.order_rule = response.data.order_ruler;
            this.img = this.order_rule.img;
            this.conditions = response.data.order_ruler.conditions;
            this.pay_type = this.conditions.pay_type;
            this.rangeFlag = this.order_rule.range_flg;
            if (this.conditions.pay_type == 1) {
              this.express_details_one = this.conditions.express_details;
              this.express_details_two = [
                { start: 0, express_price: 0, add_num: 0, add_price: 0 },
              ];
            } else {
              this.express_details_two = this.conditions.express_details;
              this.express_details_one = [{ order_fee: 0, express_price: 0 }];
            }
            // 判断接口传递的range_flg
            if (this.order_rule.range_flg == 1) {
              this.districts_one =
                response.data.order_ruler.districts &&
                response.data.order_ruler.districts.length
                  ? response.data.order_ruler.districts
                  : [];
            } else {
              this.districts_two = this.order_rule.districts;
            }
            if (
              this.conditions.pay_type == 1 &&
              this.conditions.express_details.length > 1
            ) {
              this.expressFlag = "1";
            }
            if (response.data.order_ruler.conditions.materialAs) {
              this.materialAs = response.data.order_ruler.conditions.materialAs;
            }
            if (response.data.order_ruler.conditions.materialBs) {
              this.materialBs = response.data.order_ruler.conditions.materialBs;
            }
            if (response.data.order_ruler.conditions.materials) {
              if (this.ruleType == 6) {
                var materials =
                  response.data.order_ruler.conditions.materials.sort(function (
                    a,
                    b
                  ) {
                    return a.id - b.id;
                  });
                var material_ids =
                  response.data.order_ruler.conditions.material_ids.sort(
                    function (a, b) {
                      return a.id - b.id;
                    }
                  );
                this.materials = materials.map((item, index) => {
                  return {
                    ...item,
                    ...material_ids[index],
                  };
                });
              } else {
                this.materials = response.data.order_ruler.conditions.materials;
              }
            }
            if (this.conditions.free_money && this.conditions.free_money > 0) {
              this.freeFlag = "1";
            }

            this.districts =
              response.data.order_ruler.districts &&
              response.data.order_ruler.districts.length
                ? response.data.order_ruler.districts
                : [];
          }
        }.bind(this)
      );
    },
    submit() {
      //  if (
      //   this.$refs.img_file.hasError
      // )
      //   return;
      this.$store.dispatch("fullscreenLoading");
      this.serverErrors = []; //重置远端错误提示
      this.$refs.observer.validate().then(
        async function (result) {
          if (result) {
            if (this.img_file) {
              let response = await Files.imageQacenterUpload(
                this.img_file,
                true
              );
              if (response.data.status.isOK()) {
                this.order_rule.img = response.data.data.img_name;
                this.order_rule.thumbnail = response.data.data.thumbnail;
              }
            }
            if (
              (!this.order_rule.date_from || !this.order_rule.date_to) &&
              this.ruleType == 6
            ) {
              this.$store.dispatch("fullscreenLoadingStop");
              this.$snackbar.error(
                i18n.t("MaterialOrderRule.Messages.dateNull")
              );
            } else {
              if (this.ruleType == 6) {
                var date_from1 = new Date(
                  this.order_rule.date_from.replace(/-/g, "/")
                );
                var date_to1 = new Date(
                  this.order_rule.date_to.replace(/-/g, "/")
                );
                if (date_from1 > date_to1) {
                  this.$store.dispatch("fullscreenLoadingStop");
                  this.$snackbar.error(
                    i18n.t("MaterialOrderRule.Messages.dateCompare")
                  );
                } else if (!this.img) {
                  this.$store.dispatch("fullscreenLoadingStop");
                  this.$snackbar.error(
                    i18n.t("MaterialOrderRule.Messages.imgNull")
                  );
                } else if (!this.materials.length) {
                  this.$store.dispatch("fullscreenLoadingStop");
                  this.$snackbar.error(
                    i18n.t("MaterialOrderRule.Messages.materialsNull")
                  );
                } else {
                  let district_ids = [];
                  if (this.districts.length) {
                    district_ids = this.districts.map((district) => {
                      return district.id;
                    });
                  }

                  let material_ids = [];
                  if (this.materials.length) {
                    material_ids = this.materials.map((material) => {
                      return {
                        material_id: material.id,
                        num: material.num ? material.num : 0,
                        price: material.price ? material.price : 0,
                        sub_account_price_json: material.sub_account_price_json
                          ? material.sub_account_price_json
                          : null,
                      };
                    });
                  }

                  this.submit_data = Object.assign({}, this.submit_data, {
                    max: this.conditions.max, //单笔最多下单数量
                    price: this.price, //组合金额
                    sort: this.order_rule.sort, //优先级数字
                    check_template: this.conditions.check_template, //是否响应要货模板
                    district_ids: district_ids, //适用组别
                    material_ids: material_ids, //要货商品
                    sub_account_pay_type: this.conditions.sub_account_pay_type, //分账接口
                    date_from: this.order_rule.date_from, //活动开始时间
                    date_to: this.order_rule.date_to, //活动结束时间
                    img: this.order_rule.img, //组合商品图片
                  });

                  if (this.mode == "edit" || this.order_rule.id) {
                    this.submit_data = Object.assign({}, this.submit_data, {
                      id: this.order_rule.id
                        ? this.order_rule.id
                        : this.$route.params.id,
                    });
                  }

                  OrderRules.save(
                    this.ruleType,
                    Object.assign({}, this.submit_data, {
                      name: this.order_rule.name,
                    })
                  ).then(
                    function (response) {
                      if (response.data.status.isOK()) {
                        this.order_rule = response.data.order_ruler;
                        this.$router.replace("/material-order-rules?type=6");
                        this.$snackbar.success(
                          i18n.t("MaterialOrderRule.Messages.saveSuccess")
                        );
                        if (!this.order_rule.status) {
                          this.useRuleDialog = true;
                        }
                      } else if (
                        response.data.error &&
                        response.data.error.data &&
                        "ERR333" == response.data.error.code
                      ) {
                        this.serverErrors = response.data.error.data;
                      }
                      this.$store.dispatch("fullscreenLoadingStop");
                    }.bind(this)
                  );
                }
              } else if (
                (this.ruleType == 1 || this.ruleType == 3) &&
                !this.materials.length
              ) {
                this.$store.dispatch("fullscreenLoadingStop");
                this.$snackbar.error(
                  i18n.t("MaterialOrderRule.Messages.materialsNull")
                );
              } else if (
                (this.ruleType == 2 || this.ruleType == 5) &&
                (!this.materialAs.length || !this.materialBs.length)
              ) {
                this.$store.dispatch("fullscreenLoadingStop");
                this.$snackbar.error(
                  i18n.t("MaterialOrderRule.Messages.materialsAOrBNull")
                );
              } else {
                //整理适用的分组和商品
                let district_ids = [];
                if (this.districts.length) {
                  district_ids = this.districts.map((district) => {
                    return district.id;
                  });
                }
                let material_ids = [];
                if (this.materials.length) {
                  material_ids = this.materials.map((material) => {
                    return material.id;
                  });
                }

                let materialA_ids = [];
                if (this.materialAs.length) {
                  materialA_ids = this.materialAs.map((material) => {
                    return material.id;
                  });
                }
                let materialB_ids = [];
                if (this.materialBs.length) {
                  materialB_ids = this.materialBs.map((material) => {
                    return material.id;
                  });
                }

                if (this.ruleType == 7) {
                  var express_details = [];
                  if (this.pay_type == 1) {
                    express_details = this.express_details_one.map(
                      (material) => {
                        return material;
                      }
                    );
                  } else {
                    express_details = this.express_details_two.map(
                      (material) => {
                        return material;
                      }
                    );
                  }
                  var districts_id = [];
                  if (this.rangeFlag == 1) {
                    districts_id = this.districts_one.map((district) => {
                      return district.id;
                    });
                  } else {
                    this.selection.forEach((district) => {
                      if (district.cities) {
                        district.cities.forEach((district) => {
                          districts_id.push(district.city_id);
                        });
                      } else {
                        districts_id.push(district.city_id);
                      }
                    });
                  }
                }

                //整理提交数据
                if (this.ruleType == 1) {
                  this.submit_data = Object.assign({}, this.submit_data, {
                    num: this.conditions.num,
                    must_flg: this.conditions.must_flg == "1" ? "1" : "0",
                    district_ids: district_ids,
                    material_ids: material_ids,
                  });
                } else if (this.ruleType == 2) {
                  this.submit_data = Object.assign({}, this.submit_data, {
                    district_ids: district_ids,
                    materialA_ids: materialA_ids,
                    materialB_ids: materialB_ids,
                  });
                } else if (this.ruleType == 3) {
                  this.submit_data = Object.assign({}, this.submit_data, {
                    num: this.conditions.num,
                    must_flg: this.conditions.must_flg == "1" ? "1" : "0",
                    district_ids: district_ids,
                    material_ids: material_ids,
                  });
                } else if (this.ruleType == 4) {
                  this.submit_data = Object.assign({}, this.submit_data, {
                    total_price: this.conditions.total_price,
                    cps_flg: this.conditions.cps_flg == "1" ? "1" : "0",
                    combine_flg: this.conditions.combine_flg == "1" ? "1" : "0",
                    make_auto_flg:
                      this.conditions.make_auto_flg == "1" ? "1" : "0",
                    district_ids: district_ids,
                  });
                } else if (this.ruleType == 5) {
                  this.submit_data = Object.assign({}, this.submit_data, {
                    num: this.conditions.num,
                    math: this.conditions.math,
                    district_ids: district_ids,
                    materialA_ids: materialA_ids,
                    materialB_ids: materialB_ids,
                  });
                } else if (this.ruleType == 6) {
                  this.submit_data = Object.assign({}, this.submit_data, {
                    max: this.conditions.max, //单笔最多下单数量
                    price: this.price, //组合金额
                    sort: this.order_rule.sort, //优先级数字
                    check_template: this.conditions.check_template, //是否响应要货模板
                    district_ids: district_ids, //适用组别
                    material_ids: material_ids, //要货商品
                    date_from: this.order_rule.date_from, //活动开始时间
                    date_to: this.order_rule.date_to, //活动结束时间
                    img: this.order_rule.img, //组合商品图片
                  });
                } else if (this.ruleType == 7) {
                  this.submit_data = Object.assign({}, this.submit_data, {
                    memo: this.order_rule.memo, //运费描述
                    range_flg: this.rangeFlag, //活动范围类型标志
                    free_money: this.conditions.free_money
                      ? this.conditions.free_money
                      : 0,
                    pay_type: this.pay_type, //运费计算依据
                    district_ids: districts_id, //组别
                    express_details: express_details,
                  });
                }
                //判断是新建还是编辑
                if (this.mode == "edit" || this.order_rule.id) {
                  this.submit_data = Object.assign({}, this.submit_data, {
                    id: this.order_rule.id
                      ? this.order_rule.id
                      : this.$route.params.id,
                  });
                }

                //接口提交保存
                OrderRules.save(
                  this.ruleType,
                  Object.assign({}, this.submit_data, {
                    name: this.order_rule.name,
                  })
                )
                  .then(
                    function (response) {
                      if (response.data.status.isOK()) {
                        this.order_rule = response.data.order_ruler;
                        this.$snackbar.success(
                          i18n.t("MaterialOrderRule.Messages.saveSuccess")
                        );
                        if (!this.order_rule.status) {
                          this.useRuleDialog = true;
                        }
                      } else if (
                        response.data.error &&
                        response.data.error.data &&
                        "ERR333" == response.data.error.code
                      ) {
                        this.serverErrors = response.data.error.data;
                      }
                      this.$store.dispatch("fullscreenLoadingStop");
                    }.bind(this)
                  )
                  .catch(
                    function () {
                      this.$store.dispatch("fullscreenLoadingStop");
                    }.bind(this)
                  );
              }
            }
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
    changeStatus(backToList) {
      OrderRules.changeStatus(this.order_rule.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            if (backToList) {
              this.confirmLeave = true;
              this.$router.replace(
                "/material-order-rules?type=" + this.ruleType
              );
            } else {
              this.getOrderRuleFromAPI(this.order_rule.id);
            }
          }
        }.bind(this)
      );
    },
    addExpressDetail() {
      this.express_details_one.push({ order_fee: 0, express_price: 0 });
    },
    add() {
      this.choosedCities = this.buildTree(this.selection);
    },
    buildTree(list) {
      // 获取父节点id
      var parent_ids = [];
      list.forEach((item) => {
        if (parent_ids.indexOf(item.parent_city_id) === -1) {
          parent_ids.push(item.parent_city_id);
        }
      });
      var parents = [];
      var getCities = JSON.parse(JSON.stringify(this.getCities));
      parents = getCities.filter((f) => {
        return parent_ids.includes(f.city_id);
      });

      parents.forEach((detail) => {
        var cities = [];
        list.forEach((item) => {
          if (detail.city_id == item.parent_city_id) {
            cities.push(item);
          }
        });
        detail.cities = cities;
      });

      return parents;
    },
    cut(id) {
      // selection
      // console.log(id);
      // console.log(this.selection);
      // var index = this.selection.findIndex((item) => {
      //  return item.city_id == id;
      // });
      // console.log(index);
      // if (index > -1) {
      //   this.selection.splice(index, 1);
      //   console.log(this.selection);
      // }

      this.choosedCities.forEach((detail) => {
        if (detail.city_id == id) {
          this.choosedCities.splice(
            this.choosedCities.findIndex((city) => {
              return city.city_id == id;
            }),
            1
          );
        } else {
          detail.cities.forEach((item) => {
            if (item.city_id == id) {
              detail.cities.splice(
                detail.cities.findIndex((city) => {
                  return city.city_id == id;
                }),
                1
              );
            }
          });
        }
        if (detail.cities && detail.cities.length == 0) {
          this.choosedCities.splice(
            this.choosedCities.findIndex((item) => {
              return item.city_id == detail.city_id;
            }),
            1
          );
        }
      });
    },
  },

  watch: {
    materials: {
      deep: true,
      handler() {
        if (this.materials.length) {
          if (this.ruleType == 6) {
            var price = 0;
            this.materials.forEach((element) => {
              price += Number(element.num) * Number(element.price);
            });
            this.price = price;
          }
          this.materialIds = this.materials.map((material) => {
            return material.id;
          });
        } else {
          this.price = 0;
          this.materialIds = [];
        }
      },
    },
    // 监听单次选择的商品
    choosedMaterials: {
      handler() {
        //  综合多次选择的商品
        this.choosedMaterials.forEach((material) => {
          this.materials.push(Object.assign({}, material, { price: 0 }));
        });
      },
    },
    // 监听缩略图的改变
    img: {
      handler() {
        if (!this.img) {
          this.img_file = null;
        }
      },
    },
    // 监听图片文件的改变
    img_file: {
      handler() {
        if (this.img_file) {
          var reader = new FileReader();
          reader.readAsDataURL(this.img_file);
          let that = this;
          reader.onload = function () {
            that.img = this.result;
          };
        } else {
          this.img = this.order_rule.img;
        }
      },
    },
    districts_two: {
      deep: true,
      handler() {
        var cities = JSON.parse(JSON.stringify(this.getCities));
        var districts = [];
        cities.forEach((detail) => {
          detail.cities.forEach((city) => {
            if (
              this.districts_two &&
              this.districts_two.indexOf(city.city_id) > -1
            ) {
              districts.push(city);
            }
          });
        });
        this.confirmCities = this.buildTree(districts);
        this.choosedCities = this.buildTree(districts);
        this.selection = this.buildTree(districts);
      },
    },
    getCities: {
      deep: true,
      handler() {
        if (this.mode == "edit") {
          var cities = JSON.parse(JSON.stringify(this.getCities));
          var districts = [];
          cities.forEach((detail) => {
            detail.cities.forEach((city) => {
              if (
                this.districts_two &&
                this.districts_two.indexOf(city.city_id) > -1
              ) {
                districts.push(city);
              }
            });
          });
          this.confirmCities = this.buildTree(districts);
          this.choosedCities = this.buildTree(districts);
          this.selection = this.buildTree(districts);
        }
      },
    },
    expressFlag: {
      handler() {
        if (this.expressFlag == 0) {
          this.express_details_one.splice(1);
        }
      },
    },
    choosedCities: {
      deep: true,
      handler() {
        this.selection = this.choosedCities;
      },
    },
    confirmLeave: {
      deep: true,
      handler() {
        if (this.confirmLeave) {
          if (this.toPage.path.startsWith("/material-order-rules")) {
            this.$router.replace("/material-order-rules?type=" + this.ruleType);
          } else {
            this.$router.replace(this.toPage.path);
          }
        }
      },
    },
    toEdit: {
      handler() {
        if (this.toEdit) {
          this.$router.replace({
            path: this.$route.path,
            query: { type: this.order_rule.type, mode: "edit" },
          });
          this.mode = "edit";
        }
      },
    },
    freeFlag: {
      handler() {
        if (this.freeFlag == 0) {
          this.conditions.free_money = null;
        }
      },
    },
  },
  beforeRouteLeave(to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    if (!this.order_rule.status) {
      this.toPage = to;
      if (this.confirmLeave) {
        next();
      } else if (!this.toEdit) {
        // console.log("123");
        this.isLeaveDialog = true;
        this.alertMessage = i18n.t(
          "MaterialOrderRule.Messages.isLeaveALertMsg"
        );
        next(false);
      } else {
        next();
      }
    } else {
      next();
    }
  },
};
</script>